const setFixed = (element) => {
    const checkMediaSize = window.matchMedia('(max-width: 991px)');
    const position = element.getBoundingClientRect().top + element.clientHeight + 15 - window.outerHeight;

    if (!checkMediaSize.matches || position > 0) {
        element.classList.remove('is-fixed');
    }
    else {
        element.classList.add('is-fixed');
    }
};

export default () => {
    const element = document.querySelector('.form__group--footer.form__group--submit');

    if (!element) {
        return;
    }

    // Load
    setFixed(element);

    // Scroll
    document.addEventListener('scroll', () => {
        setFixed(element);
    });

    // Resize
    window.addEventListener('resize', () => {
        setFixed(element);
    });
};
